<template>
  <!--
    作者：kmdshop
    时间：2020-06-25
    描述：插件中心-限时秒杀-秒杀活动-基础设置
  -->
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="商家名称" prop="name" :rules="[{ required: true, message: '请输入商家名称', trigger: 'blur' }]">
      <el-input v-model="form.name" placeholder="请输入商家名称" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="联系方式" prop="mobile" :rules="[{ required: true, message: '请输入联系方式', trigger: 'blur' }]">
      <el-input v-model="form.mobile" placeholder="请输入联系方式" class="max-w460"></el-input>
    </el-form-item>
    
    <el-form-item label="商家评级（1～5）">
      <el-input v-model="form.grade" placeholder="商家评级（1～5）" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="营业时间（09:00-18:00）">
      <el-input v-model="form.shop_hours" placeholder="营业时间（09:00-18:00）" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="商家等级">
      <el-select v-model="form.kmd_grade_id" placeholder="-请选择等级-">
        <el-option v-for="item in gradeList" :value="item.kmd_grade_id" :key="item.kmd_grade_id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
    
    <el-form-item label="商家logo">
      <el-row>
        <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
        <div v-if="form.image_id!=''" class="img">
          <img :src="form.file_path" width="100" height="100" />
        </div>
      </el-row>
    </el-form-item>

    <el-form-item label="所属行业分类：" prop="category_id">
      <el-select v-model="form.category_id">
        <template v-for="cat in category">
          <el-option :value="cat.category_id" :key="cat.category_id" :label="cat.name"></el-option>
          <template v-if="cat.child !== undefined" v-for="two in cat.child">
            <el-option :value="two.category_id" :key="two.category_id" :label="two.name" style="padding-left: 30px;"></el-option>
            <template v-if="two.child !== undefined" v-for="three in two.child">
              <el-option :value="three.category_id" :key="three.category_id" :label="three.name" style="padding-left: 60px;"></el-option>
            </template>
          </template>
        </template>
      </el-select>
    </el-form-item>

    <el-form-item label="详细地址" prop="address">
      <el-input v-model="form.address" placeholder="请输入详细地址" class="max-w460"></el-input>
    </el-form-item>
    
    <el-form-item label="坐标">
      <el-row class="mb16">
        <el-col :span="24">
          <el-input v-model="form.coordinate" class="max-w460"></el-input>
        </el-col>
      </el-row>
      <el-row class="mb16">
        <el-col :span="24">
          <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
        </el-col>
      </el-row>
    </el-form-item>

    <el-form-item label="禁止下单购买" prop="is_forbidden_buy">
      <el-radio-group v-model="form.is_forbidden_buy">
        <el-radio :label="1">是</el-radio>
        <el-radio :label="0">否</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="商家简介">
      <el-input type="textarea" v-model="form.introduce" placeholder="请输入简介" class="max-w460"></el-input>
    </el-form-item>
    
    <el-form-item label="备注">
      <el-input type="textarea" v-model="form.remark" placeholder="请输入备注" class="max-w460"></el-input>
    </el-form-item>

    <div class="common-form">通知设置</div>
    <el-form-item label="绑定通知手机号">
      <el-input type='textarea' v-model="form.notice" placeholder="请输入通知手机号" class="max-w460"></el-input>
      <div>可多个，逗号隔开</div>
    </el-form-item>

    <!-- 新增：轮播图设置 -->
    <div class="common-form">轮播图设置</div>
    <el-form-item label="轮播图类型：">
      <el-radio-group v-model="bannerConfig.tab_type">
        <el-radio :label="1">基础</el-radio>
        <el-radio :label="2">盒子</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="轮播图高度：" v-if="bannerConfig.tab_type == 1">
      <el-slider v-model="bannerConfig.height" :min="0" :max="1400" show-input></el-slider>
      <div>0是默认高度</div>
    </el-form-item>

    <el-form-item label="圆角：">
      <el-slider v-model="bannerConfig.yj" :min="0" :max="100" show-input></el-slider>
    </el-form-item>

    <el-form-item label="上下边距：" v-if="bannerConfig.tab_type == 1">
      <el-slider v-model="bannerConfig.paddingTop" show-input></el-slider>
    </el-form-item>

    <el-form-item label="宽度：" v-if="bannerConfig.tab_type == 1">
      <el-slider v-model="bannerConfig.width" :min="0" :max="100" show-input></el-slider>
    </el-form-item>

    <el-form-item label="指示点颜色：" v-if="bannerConfig.tab_type == 1">
      <div class="d-s-c">
        <el-color-picker v-model="bannerConfig.btnColor"></el-color-picker>
        <el-button type="button" style="margin-left: 10px" @click.stop="resetColor('btnColor', '#ffffff')">重置</el-button>
      </div>
    </el-form-item>

    <el-form-item label="切换时间：" v-if="bannerConfig.tab_type == 1">
      <el-input v-model="bannerConfig.interval" placeholder="请输入切换时间（毫秒）"></el-input>
      <p>轮播图自动切换的间隔时间，单位：毫秒</p>
    </el-form-item>

    <!-- 轮播图内容管理 -->
    <el-form-item label="轮播图内容：">
      <div class="banner-content">
        <div class="param-img-item" v-for="(banner, index) in bannerConfig.data" :key="index">
          <div class="delete-box">
            <i class="el-icon-delete-solid" @click="deleteBanner(index)"></i>
          </div>
          <div class="pic">
            <img :src="banner.imgUrl" alt="" @click="selectBannerImage(banner, 'imgUrl')" v-if="banner.imgUrl" />
            <div v-else class="empty-img" @click="selectBannerImage(banner, 'imgUrl')">
              <i class="el-icon-picture-outline"></i>
              <div>点击选择图片</div>
            </div>
          </div>
          <p class="tc gray9">建议尺寸比例750x360 像素，多个图片请保持尺寸一致</p>
          
          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">跳转地址：</span>
              <el-input placeholder="请选择跳转地址" :value="banner.name + banner.linkUrl" readonly></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)">选择链接</el-button>
            </div>
          </div>

          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">标题：</span>
              <el-input placeholder="请输入标题" v-model="banner.title"></el-input>
            </div>
          </div>

          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">副标题：</span>
              <el-input placeholder="请输入副标题" v-model="banner.fu_title"></el-input>
            </div>
          </div>
        </div>

        <div class="d-c-c mt20">
          <el-button @click="addBanner">添加一个图片组件</el-button>
          <el-button @click="addBanner('video')" v-if="bannerConfig.tab_type == 1">添加一个视频组件</el-button>
        </div>
      </div>
    </el-form-item>

    <div class="common-form">登陆信息</div>
    <el-form-item label="绑定用户">
      <div class="d-s-s d-c">
        <el-button @click="openGetuser" icon="el-icon-plus">选择会员</el-button>
        <div class="d-s-s" v-if="form.user">
          <img :src="form.user.avatarUrl" class="radius" width="30" height="30" />
        </div>
        <div class="d-s-s" v-if="form.user">
          <p class="lh18 ww100 text-ellipsis">用户昵称：{{form.user.nickName}}</p>
        </div>
        <div class="d-s-s" v-if="form.user">
          <p class="lh18 ww100 text-ellipsis">手机号：{{form.user.mobile}}</p>
        </div>
      </div>
      <span>绑定完成后，登陆后台只跟该用户有关</span>
    </el-form-item>
    
    <el-form-item label="后台账号" prop="user_name" :rules="[{required: true,message: ' '}]">
      <el-input type='mobile' v-model="form.user_name" v-if="!is_edit" placeholder="请输入手机号" class="max-w460"></el-input>
      <el-input type='mobile' v-model="form.user_name" v-if="is_edit" readonly placeholder="请输入手机号" class="max-w460"></el-input>
      @{{app_id}}
    </el-form-item>
    
    <el-form-item label="后台密码" prop="password">
      <el-input v-model="form.password" placeholder="请输入密码(默认123456)" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="商家状态">
      <el-radio-group v-model="form.status">
        <el-radio :label="1">启用</el-radio>
        <el-radio :label="0">禁用</el-radio>
      </el-radio-group>
    </el-form-item>
    
    <el-form-item label="排序">
      <el-input type="number" v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
    </el-form-item>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc"></Upload>

    <!--选择用户-->
    <GetUser :is_open="open_getuser" @close="closeGetuserFunc"></GetUser>

    <!-- 链接选择组件 -->
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset"></Setlink>

    <!-- 轮播图图片选择组件 -->
    <Upload v-if="isBannerUpload" :isupload="isBannerUpload" @returnImgs="returnBannerImgsFunc"></Upload>
  </div>
</template>

<script>
import Getpoint from '@/components/map/Getpoint.vue';
import Upload from '@/components/file/Upload';
import GetUser from '@/components/user/GetUser.vue';
import Setlink from "@/components/setlink/Setlink";

export default {
  components: {
    Upload,
    Getpoint,
    GetUser,
    Setlink
  },
  data() {
    return {
      /*轮播图配置*/
      bannerConfig: {
        tab_type: 1, // 1-基础，2-盒子
        height: 0,
        yj: 0,
        paddingTop: 0,
        width: 100,
        btnColor: '#ffffff',
        interval: 3000,
        data: []
      },
      /*是否选择链接*/
      is_linkset: false,
      linkIndex: null,
      /*获取用户是否显示*/
      open_getuser: false,
      /*选择的用户列表*/
      select_user: {},
      /* 上传类型 */
      uploadtype: '',
      /* 是否打开其他上传 */
      isOtherUpload: false,
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否上传图片*/
      isupload: false,
      /*是否上传轮播图图片*/
      isBannerUpload: false,
      /*当前操作的轮播图项*/
      currentBannerItem: null,
      currentBannerField: ''
    };
  },
  props: {
    form: Object,
    gradeList: Array,
    app_id: Number,
    is_edit: Boolean,
    category: Array,
  },
  created() {
    // 初始化轮播图数据
    this.initBannerConfig();
  },
  methods: {
    /*初始化轮播图配置*/
    initBannerConfig() {
      // 如果form中有轮播图配置，则使用已有的配置
      if (this.form.banner_config) {
        try {
          // 如果banner_config是字符串，需要解析
          if (typeof this.form.banner_config === 'string') {
            this.bannerConfig = JSON.parse(this.form.banner_config);
          } else {
            this.bannerConfig = JSON.parse(JSON.stringify(this.form.banner_config));
          }
        } catch (e) {
          console.error('解析轮播图配置失败:', e);
          // 使用默认配置
          this.resetBannerConfig();
        }
      } else {
        // 使用默认配置
        this.resetBannerConfig();
      }
    },

    /*重置轮播图配置*/
    resetBannerConfig() {
      this.bannerConfig = {
        tab_type: 1,
        height: 0,
        yj: 0,
        paddingTop: 0,
        width: 100,
        btnColor: '#ffffff',
        interval: 3000,
        data: []
      };
    },

    /*重置颜色*/
    resetColor(key, defaultValue) {
      this.bannerConfig[key] = defaultValue;
    },

    /*添加轮播图*/
    addBanner(type = 'image') {
      const newBanner = {
        imgUrl: '',
        linkUrl: '',
        name: '',
        title: '',
        fu_title: '',
        type: type
      };
      
      if (type === 'video') {
        newBanner.video = '';
      }
      
      this.bannerConfig.data.push(newBanner);
    },

    /*删除轮播图*/
    deleteBanner(index) {
      this.$confirm('确定要删除这个轮播图吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.bannerConfig.data.splice(index, 1);
      }).catch(() => {});
    },

    /*选择轮播图图片*/
    selectBannerImage(banner, field) {
      this.currentBannerItem = banner;
      this.currentBannerField = field;
      this.isBannerUpload = true;
    },

    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.linkIndex = index;
    },

    /*关闭链接选择*/
    closeLinkset(e) {
      this.is_linkset = false;
      if (e && this.linkIndex !== null) {
        this.bannerConfig.data[this.linkIndex].linkUrl = e.url;
        this.bannerConfig.data[this.linkIndex].name = "链接到" + " " + e.type + " " + e.name;
      }
      this.linkIndex = null;
    },

    /*保存轮播图配置到form*/
    saveBannerConfig() {
      this.form.banner_config = JSON.parse(JSON.stringify(this.bannerConfig));
    },

    /*轮播图图片上传回调*/
    returnBannerImgsFunc(e) {
      if (e != null && e.length > 0 && this.currentBannerItem) {
        if (this.currentBannerField === 'imgUrl') {
          this.currentBannerItem.imgUrl = e[0].file_path;
        } else if (this.currentBannerField === 'video') {
          this.currentBannerItem.video = e[0].file_path;
        }
      }
      this.isBannerUpload = false;
      this.currentBannerItem = null;
      this.currentBannerField = '';
    },

    /*原有的方法保持不变*/
    openUpload(e) {
      this.isupload = true;
    },

    getMapdataFunc(e) {
      this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
    },

    choseFunc(e) {
      this.form.coordinate = e.location.lat + ',' + e.location.lng;
      this.form.address = e.address;
    },

    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.file_path = e[0].file_path;
        this.form.image_id = e[0].file_id;
      }
      this.isupload = false;
    },

    openGetuser() {
      this.open_getuser = true;
    },

    closeGetuserFunc(e) {
      if (e.type != 'error') {
        this.form.user = e.params[0];
        this.form.user_id = e.params[0].user_id;
        this.form.user_name = this.form.user.mobile;
        this.form.password = 123456;
      }
      this.open_getuser = false;
    }
  },
  watch: {
    // 监听轮播图配置变化，自动保存到form
    bannerConfig: {
      handler(newVal) {
        this.saveBannerConfig();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
.img {
  width: 100px;
  margin-top: 10px;
  height: 130px;
  margin-right: 10px;
}
.delete-btn {
  position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  right: -8px;
  top: -8px;
  color: red;
}

/* 轮播图设置样式 */
.banner-content {
  .param-img-item {
    position: relative;
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    
    .delete-box {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
      color: #ff4d4f;
      font-size: 18px;
    }
    
    .pic {
      margin-bottom: 10px;
      img {
        width: 200px;
        height: 100px;
        object-fit: cover;
        border-radius: 4px;
        cursor: pointer;
      }
      .empty-img {
        width: 200px;
        height: 100px;
        border: 1px dashed #dcdfe6;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #909399;
        i {
          font-size: 24px;
          margin-bottom: 8px;
        }
      }
    }
    
    .url-box {
      margin-top: 10px;
    }
    
    .key-name {
      display: inline-block;
      width: 80px;
      font-size: 14px;
    }
  }
}

.d-s-c {
  display: flex;
  align-items: center;
}
.d-c-c {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-1 {
  flex: 1;
}
.ml10 {
  margin-left: 10px;
}
.mt20 {
  margin-top: 20px;
}
.tc {
  text-align: center;
}
.gray9 {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/supply/supply/part/Basic.vue